// extracted by mini-css-extract-plugin
export default {"root":"IFqpPb","responsiveContainer":"MT73Y8","clickable":"egvlKy","bg":"CWq09o","lightbox-layer":"Zj22Mk","lightboxLayer":"Zj22Mk"};